<script>
export default {
    name: 'IconArrowLeft',
}
</script>
<template>
    <svg xmlns="http://www.w3.org/2000/svg" class="base-icon icon-arrow-left" viewBox="0 0 64 64"><g clip-path="url(#a)"><path fill="currentColor"  fill-rule="evenodd" d="M31.96 0 0 31.867l.133.132-.133.133L31.96 64l5.64-5.624-22.464-22.4H64v-7.952l-48.864-.001 22.465-22.4L31.96 0Z" clip-rule="evenodd"/></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h64v64H0z"/></clipPath></defs></svg>
</template>
